export default __webpack_public_path__ + "static/media/Sde_Azul_Prancheta.53b2da43.png";